export const sessionExpiredResponse = {
  code: 401,
  reason: 'Unauthorized',
  message: 'La durée de la session est dépassée',
  detail: {
    errorCode: '110',
  },
};
